// File: src/pages/SignupPage.js
// This version fixes the build error and restores the "Full Name" field.
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

function SignupPage() {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (password !== confirmPassword) {
      return setError('Passwords do not match.');
    }
    if (password.length < 6) {
        return setError('Password must be at least 6 characters long.');
    }

    try {
      await axios.post('/api/register', { fullName, email, password });
      setSuccess('Registration successful! Redirecting to login...');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed. Please try again.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="bg-black p-8 md:p-12 rounded-lg shadow-lg w-full max-w-md border-t-4 border-magenta">
        <div className="text-center mb-8">
          <Link to="/">
            <img src="/Logo.png" alt="R.A.W. Fitness Logo" className="h-16 w-auto mx-auto mb-4" />
          </Link>
          <h2 className="text-3xl font-bold text-white">Create Your Account</h2>
          <p className="text-gray-400">Join us and Rise and Win!</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label className="block text-gray-400 text-sm font-bold mb-2" htmlFor="fullName">
              Full Name
            </label>
            <input
              className="appearance-none block w-full bg-gray-800 text-white border border-gray-700 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-700 focus:border-magenta"
              id="fullName"
              type="text"
              placeholder="e.g. Jane Doe"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
            />
          </div>
          <div className="mb-6">
            <label className="block text-gray-400 text-sm font-bold mb-2" htmlFor="email">
              Email Address
            </label>
            <input
              className="appearance-none block w-full bg-gray-800 text-white border border-gray-700 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-700 focus:border-magenta"
              id="email"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-6">
            <label className="block text-gray-400 text-sm font-bold mb-2" htmlFor="password">
              Password
            </label>
            <input
              className="appearance-none block w-full bg-gray-800 text-white border border-gray-700 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-700 focus:border-magenta"
              id="password"
              type="password"
              placeholder="******************"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
           <div className="mb-6">
            <label className="block text-gray-400 text-sm font-bold mb-2" htmlFor="confirm-password">
              Confirm Password
            </label>
            <input
              className="appearance-none block w-full bg-gray-800 text-white border border-gray-700 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-700 focus:border-magenta"
              id="confirm-password"
              type="password"
              placeholder="******************"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          {error && <p className="text-red-500 text-xs italic text-center mb-4">{error}</p>}
          {success && <p className="text-lime text-xs italic text-center mb-4">{success}</p>}
          <div className="mb-6">
            <button className="w-full bg-magenta text-black font-bold py-3 px-4 rounded-lg hover:bg-opacity-80 transition duration-300 glow-magenta" type="submit">
              Create Account
            </button>
          </div>
          <p className="text-center text-gray-400">
            Already have an account? <Link to="/login" className="text-lime font-bold hover:underline">Login</Link>
          </p>
        </form>
      </div>
    </div>
  );
}

export default SignupPage;
